import { render } from "./TidalIdField.vue?vue&type=template&id=2f85cf9e&scoped=true"
import script from "./TidalIdField.vue?vue&type=script&lang=js"
export * from "./TidalIdField.vue?vue&type=script&lang=js"

import "./TidalIdField.vue?vue&type=style&index=0&id=2f85cf9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f85cf9e"]])

export default __exports__